import MetricCard from "./graphs/MetricCard";
import ClientsTable from "./graphs/ClientsTable";
import RevenueChart from "./graphs/RevenueChart";
import ModulesChart from "./graphs/ModulesChart";
import "../../styles/superAdmin/dashboard.css";
import { metrics } from "./dummydata/metricData";
import { useGetModulesAnalytics } from "../../hooks/useGetModulesAnalytics";
import { useGetUsersStats } from "../../hooks/useGetUsersStats";
import UsersChart from "./graphs/UsersChart";
import StatsWidgets from "./StatsWidgets";
import { useGetClientsStats } from "../../hooks/useGetClientsStats";
import SkeletonUI from "../UI/superAdmin/loaders/SkeletonUI";
import { clearToken } from "../util/auth";
import { useEffect } from "react";

const getGreeting = () => {
  const hour = new Date().getHours();

  if (hour >= 5 && hour < 12) return "Good Morning";
  if (hour >= 12 && hour < 17) return "Good Afternoon";
  if (hour >= 17 && hour < 21) return "Good Evening";
  return "Good Night";
};

export default function Dashboard() {

  const { data: modulesData, isLoading, error } = useGetModulesAnalytics();
  const {data: usersStats, isLoading: userStatsLoading} = useGetUsersStats();
  const { data: clientStats, isLoading: clientStatsLoading } = useGetClientsStats();

  useEffect(() => {
  const expiry = localStorage.getItem("superAdminTokenExpiry");
  if (!expiry) return;

  const now = new Date().getTime();
  const timeLeft = parseInt(expiry) - now;

  if (timeLeft > 0) {
    const timeout = setTimeout(() => {
      clearToken();
      window.location.href = "/super_admin/login";
    }, timeLeft);

    return () => clearTimeout(timeout); 
  } else {
    clearToken();
    window.location.href = "/super_admin/login";
  }
}, []);


  return (
    <div className="dashboard-container">
      <h2 className="welcome-message mt-5" style={{color : "#16166C"}} id="negative-margin">
        {getGreeting()}, Super admin!{" "}
        <span role="img" aria-label="wave">
          👋🏼
        </span>
      </h2>

      <div className="row g-4 mb-4">
          <div className="w-100 row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5 g-4 justify-content-lg-start justify-content-center align-items-center">
            <StatsWidgets clientStats={clientStats}/>
          </div>
    
      </div>

      <div className="row g-4 mb-4">
        <div className="col-12 col-lg-5">
          <ClientsTable usersStats={usersStats} userStatsLoading={userStatsLoading}/>
        </div>
        <div className="col-12 col-lg-7">
          {userStatsLoading ? (
            <SkeletonUI/>
          ) : (
            <UsersChart usersStats={usersStats} userStatsLoading={userStatsLoading}/>
          )}
        </div>
      </div>

      <div className="row">
        <div className="col-12">
             {userStatsLoading ? (
            <SkeletonUI/>
          ) : (
             <ModulesChart modulesData={modulesData} />
          )}
         
        </div>
      </div>
    </div>
  );
}
